// extracted by mini-css-extract-plugin
export default {"container":"SpecialSelect_container__oZrv4"};